import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Text } from '@react-pdf/renderer';
import cx from 'classnames';

import CustomBadge from 'src/components/custom_components/CustomBadge';
import FontAwesomeIcon from 'src/components/custom_components/PdfFontAwesomeIcon';

import { cls } from 'src/utils/reactPdfStyles';

interface IBadgeWithIconProps {
  icon: IconDefinition;
  text: string;
  className?: string;
}

const BadgeWithIcon = ({ icon, text, className }: IBadgeWithIconProps) => {
  return (
    <CustomBadge className={cx('badge text-start', className)}>
      <FontAwesomeIcon icon={icon} style={cls('me-2 text-white')} />
      <Text hyphenationCallback={(word) => [word]} style={cls('me-4')}>
        {text}
      </Text>
    </CustomBadge>
  );
};

export default BadgeWithIcon;
